import { z } from 'zod';

import type {
  CashExpenseCategoryDto,
  CreateCashExpenseCategoryRequest,
  CreateCashExpenseCategoryResponse,
  DisableCashExpenseCategoryRequest,
  DisableCashExpenseCategoryResponse,
  ListCashExpenseCategoriesRequest,
  ListCashExpenseCategoriesResponse,
} from './cash-expense-categories.dto.js';
import { CashConfigProvenanceSchema } from './cash-locations.schema.js';

const timestampSchema = z.iso.datetime();

export const CashExpenseCategoryDtoSchema: z.ZodType<CashExpenseCategoryDto> = z.object({
  id: z.uuid(),
  companyId: z.uuid(),
  name: z.string().trim().min(1).max(200),
  isActive: z.boolean(),
  provenance: CashConfigProvenanceSchema,
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const CreateCashExpenseCategoryRequestSchema: z.ZodType<CreateCashExpenseCategoryRequest> =
  z.object({
    companyId: z.uuid(),
    operationId: z.uuid(),
    occurredAt: timestampSchema.optional(),
    name: z.string().trim().min(1).max(200),
  });

export const CreateCashExpenseCategoryResponseSchema: z.ZodType<CreateCashExpenseCategoryResponse> =
  z.object({
    cashExpenseCategory: CashExpenseCategoryDtoSchema,
  });

export const ListCashExpenseCategoriesRequestSchema: z.ZodType<ListCashExpenseCategoriesRequest> =
  z.object({
    companyId: z.uuid(),
    activeOnly: z.coerce.boolean().optional(),
  });

export const ListCashExpenseCategoriesResponseSchema: z.ZodType<ListCashExpenseCategoriesResponse> =
  z.object({
    items: z.array(CashExpenseCategoryDtoSchema),
  });

export const DisableCashExpenseCategoryRequestSchema: z.ZodType<DisableCashExpenseCategoryRequest> =
  z.object({
    companyId: z.uuid(),
    categoryId: z.uuid(),
    operationId: z.uuid(),
    occurredAt: timestampSchema.optional(),
  });

export const DisableCashExpenseCategoryResponseSchema: z.ZodType<DisableCashExpenseCategoryResponse> =
  z.object({
    cashExpenseCategory: CashExpenseCategoryDtoSchema,
  });
